export function extractProductEntryIdFromUrn(
  urn?: string | null,
): string | null {
  if (!urn) return null
  const entryId = urn.split("/entries/").pop()
  return entryId || null
}
